/**
 * @desc        Redux reducers index
 * @version     1.0.1 (Added automations reducer) - 27 May 2026
 */

import alertsReducer from 'api/alerts-config.js'
import farmAnimals from 'api/farmAnimals.js'
import farmEvents from 'api/farmEvents.js'
import livestock2 from 'api/livestock2.js'
import paddocksReducer from 'api/paddocks.js'
import riskCompliance from 'api/riskCompliance.js'
import usersReducer from 'api/users.js'
import theme from 'app-config/ThemeOptions.js' // added from theme
import gpevents from 'redux/reducers/planningEvents/planning-events-reducer.js'
import awsut from './aws/aws-cognito-accounts-reducer.js'
import aws from './aws/aws-reducer.js'
import assetTypes from './farmdeck/asset-types-reducer.js'
import assets from './farmdeck/assets-reducer.js'
import chemicalsrecord from './farmdeck/chemicals-record-reducer.js'
import feeds from './farmdeck/feed-reducer.js'
import oldAccountReducer from './farmdeck/internal-reducer.js'
import livestock from './farmdeck/livestock-reducer.js'
import payload from './farmdeck/payload-reducer.js'
import sensor from './farmdeck/sensor-reducer.js'
import sensortype from './farmdeck/sensor-type-reducer.js'
import taskmanager from './farmdeck/taskmanager-reducer.js'
import ui from './farmdeck/ui-reducer.js'
import automations from './firebase/automations-reducer.js'
import notifications from './firebase/notification-reducer.js'
import payments from './payments/payments-reducer.js'
import weather from './weather-reducer.js'

// const combinedAccountReducer = (state, action) => {
//     const intermediateState = oldAccountReducer(state, action)
//     return {
//         ...intermediateState,
//         farms: farmsReducer(intermediateState.farms, action),
//     }
// }

// const accountReducer = combineReducers({
//     // temp until i swap user/me over
//     account: combinedAccountReducer,
// })

const reducers = {
    account: oldAccountReducer,
    alerts: alertsReducer, // new way of doing it
    assets,
    assetTypes,
    aws,
    awsut,
    gpevents,
    livestock,
    paddocks: paddocksReducer,
    payload,
    sensortype,
    sensor,
    chemicalsrecord,
    theme,
    users: usersReducer,
    weather,
    ui,
    notifications,
    automations,
    taskmanager,
    feeds,
    payments,
    farmAnimals,
    livestock2,
    farmEvents,
    riskCompliance,
}

export default reducers

// import users from './farmdeck/users-reducer.js'
// old way of doing it
// const reducers = {
// account,
// assets,
// assetTypes,
// aws,
// awsut,
// gpevents,
// livestock,
// paddocks,
// payload,
// sensortype,
// sensor,
// chemicalsrecord,
// theme,
// users,
// weather,
// ui,
// notifications,
// taskmanager,
// feeds,
// payments,
// }

// export default reducers
